import React, { useEffect, useRef, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { getIn } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import notifications from 'lib/notifications';
import { loadMapplsSearchPlugin } from 'lib/mappls';

const FormikMaterialTextField = (props) => {
  const {
    field,
    form: { touched, errors, values },
    variant,
    disabled,
    cb,
    isMarketView,
    isFarmerUser,
    ...rest
  } = props;

  const [inputValue, setInputValue] = useState('');
  const inputIdRef = useRef(`mappls-search-${Math.random().toString(36).slice(2)}`);
  const cbRef = useRef(cb);
  const isMarketViewRef = useRef(isMarketView);

  useEffect(() => {
    cbRef.current = cb;
    isMarketViewRef.current = isMarketView;
  }, [cb, isMarketView]);

  useEffect(() => {
    setInputValue(field.value);
  }, [field.value]);

  const handleInputChange = (e) => {
    let value = e.target.value;
    setInputValue(value);
  };

  useEffect(() => {
    let isMounted = true;

    loadMapplsSearchPlugin()
      .then((mappls) => {
        const inputElement = document.getElementById(inputIdRef.current);
        if (!isMounted || !inputElement || !mappls?.search) {
          return;
        }

        const optional_config = {
          location: [28.61, 77.23],
          bridge: false,
          tokenizeAddress: true,
          geolocation: false,
        };

        new mappls.search(inputElement, optional_config, function (data1) {
          if (!isMounted) {
            return;
          }

          console.log('mappls data1 >>', data1);

          if (data1 && !Object.prototype.hasOwnProperty.call(data1, 'error')) {
            const selectedLocation = Array.isArray(data1) ? data1[0] : null;
            const shouldUpdateMarketValue = isMarketViewRef.current;
            if (
              !data1[0]?.addressTokens?.district ||
              (!data1[0]?.addressTokens?.village &&
                !data1[0]?.addressTokens?.city &&
                !data1[0]?.addressTokens?.subDistrict)
            ) {
              notifications.show({
                type: 'error',
                message: 'Village or Town not found. Please search your Village/ Town again',
                key: 'req-form',
              });
              shouldUpdateMarketValue ? setInputValue(selectedLocation?.placeName) : null;
              cbRef.current && cbRef.current({});
            } else {
              shouldUpdateMarketValue
                ? setInputValue(`${selectedLocation?.placeName}, ${selectedLocation?.placeAddress}`)
                : null;
              cbRef.current && cbRef.current(data1);
            }
          }
        });
      })
      .catch((err) => {
        console.error('Mappls search failed to load', err);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div>
      <input
        type="text"
        id={inputIdRef.current}
        name={inputIdRef.current}
        className="search-outer form-control as-input"
        placeholder="Search location"
        required=""
        spellCheck="false"
        value={inputValue}
        disabled={disabled}
        onChange={handleInputChange}></input>

      <span
        style={{
          color: 'var(--unnamed-color-f44336)',
          fontSize: 'var(--fs-base__three)',
          fontFamily: 'var(--unnamed-font-segoeUI)',
        }}>
        {errors.location_code}
      </span>
    </div>
  );
};

export default FormikMaterialTextField;
